import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { JobCardPage } from '@/features/attendance/pages/JobCardPage';
import {
  downloadShiftJobCard,
  shiftJobCardQueryOptions,
} from '@/features/attendance/api/attendance.api';
import { jobCardSearchSchema } from '@/features/attendance/types/attendance.types';

export const Route = createFileRoute('/_auth/attendance/shift-job-card')({
  validateSearch: jobCardSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Shift Job Card">
      <Suspense fallback={<PageLoader />}>
        <JobCardPage
          queryOptions={shiftJobCardQueryOptions}
          onExport={downloadShiftJobCard}
          title="Job Card Dashboard (Night Shift)"
          selfRoute="/attendance/shift-job-card"
          employeeReportRoute="/attendance/shift-employee-report"
        />
      </Suspense>
    </ErrorBoundary>
  ),
});
